import $ from 'jquery';
import 'multiple-select/dist/multiple-select';
import 'bootstrap/js/dist/tab';

function filterLaw() {
  var lawList = $('.law-list-item');
  var totalItems = lawList.length;
  var filteredResults = 0;

  // The .selected class is necessary to make the "Select all"
  // option show all records when unchecked.

  var selectedTechnologies = $('.tech-check.selected input[type=checkbox]:checked').map(function() {
    return $(this).val().toString();
  }).get();

  var selectedUtilities = $('.utility-check.selected input[type=checkbox]:checked').map(function() {
    return $(this).val().toString();
  }).get();

  var selectedCounties = $('.county-check.selected input[type=checkbox]:checked').map(function() {
    return $(this).val().toString();
  }).get();

  lawList.hide().each(function() {
    var technologyMatch = true;
    if (selectedTechnologies.length > 0 && $("li.tech-check:not(.selected)").length > 0) {
      technologyMatch = doArraysIntersect(selectedTechnologies, $(this).data('technology'));
    }

    var utilityMatch = true;
    if (selectedUtilities.length > 0 && $("li.utility-check:not(.selected)").length > 0) {
      utilityMatch = selectedUtilities.indexOf($(this).data('utility').toString()) !== -1;
    }

    var countyMatch = true;
    if (selectedCounties.length > 0 && $("li.county-check:not(.selected)").length > 0) {
      countyMatch = doArraysIntersect(selectedCounties, $(this).data('county'));
    }

    if (technologyMatch && utilityMatch && countyMatch) {
      $(this).show();
      filteredResults += 1;
    }
  });

  var filteredResultsLabel = filteredResults === 1 ? " result" : " results";
  var totalItemsLabel = totalItems === 1 ? " item" : " items";

  if (filteredResults !== totalItems) {
    $('#resultsCount').text(filteredResults + filteredResultsLabel + " filtered from " + totalItems + totalItemsLabel);
  } else {
    $('#resultsCount').text(totalItems + totalItemsLabel);
  }

  $('ul.filtered-list-items').each(function() {
    $(this).children().last().hide();
    if ($(this).children(':visible').length === 0) {
      $(this).children().last().show();
    }
  });
}

function doArraysIntersect(selectedOptions, lawData) {
  return selectedOptions.some(function(selected) {
    return lawData.some(function(law) {
      return selected.toString() === law.toString();
    });
  });
}

function handleParams() {
  if (window.location.pathname.startsWith('/laws/state_summary') || window.location.pathname.startsWith('/laws/fed_summary')) {
    var url = new URL(location);

    var technologies = [];
    $('li.tech-check.selected input').each(function() {
      technologies.push($(this).attr("value"));
    });

    if (technologies.length > 0) {
      url.searchParams.set('technologies', technologies);
    } else {
      url.searchParams.delete('technologies');
    }

    var utilities = [];
    $('li.utility-check.selected input').each(function() {
      utilities.push($(this).attr("value"));
    });

    if (utilities.length > 0) {
      url.searchParams.set('utilities', utilities);
    } else {
      url.searchParams.delete('utilities');
    }

    var counties = [];
    $('li.county-check.selected input').each(function() {
      counties.push($(this).attr("value"));
    });

    if (counties.length > 0) {
      url.searchParams.set('counties', counties);
    } else {
      url.searchParams.delete('counties');
    }

    if (url.search.length > 0) {
      window.history.replaceState('', document.title, decodeURIComponent(url.search));
    } else {
      window.history.replaceState('', document.title, window.location.pathname);
    }
  }
}

$(document).ready(function() {
  var selectMultipleTech = $('.select-multiple-tech')

  $(selectMultipleTech).multipleSelect({
    onClick: function () {
      filterLaw();
      handleParams();
    },
    onCheckAll: function() {
      $('li.tech-check').addClass('selected');
      filterLaw();
      handleParams();
    },
    onUncheckAll: function() {
      $('li.tech-check').removeClass('selected');
      filterLaw();
      handleParams();
    },
    placeholder: "All selected",
    maxHeight: 239,
  });

  var selectMultipleUtility = $('.select-multiple-utility');

  $(selectMultipleUtility).multipleSelect({
    onClick: function () {
      filterLaw();
      handleParams();
    },
    onCheckAll: function() {
      $('li.utility-check').addClass('selected');
      filterLaw();
      handleParams();
    },
    onUncheckAll: function() {
      $('li.utility-check').removeClass('selected');
      filterLaw();
      handleParams();
    },
    placeholder: "All selected",
    maxHeight: 239,
  });

  var selectMultipleCounty = $('.select-multiple-county');

  $(selectMultipleCounty).multipleSelect({
    onClick: function () {
      filterLaw();
      handleParams();
    },
    onCheckAll: function() {
      $('li.county-check').addClass('selected');
      filterLaw();
      handleParams();
    },
    onUncheckAll: function() {
      $('li.county-check').removeClass('selected');
      filterLaw();
      handleParams();
    },
    placeholder: "All selected",
    maxHeight: 239,
  });

  filterLaw();
  handleParams();

  $("#print").children().click(function(){
    $("#advanced-search").hide();
  });

  $("#print_preview_cancel").click(function(){
    $("#advanced-search").show();
  });

  $(".tli_content_header").click(function(){
    $(this).parent().children(".tli_content_body").toggle();
    $(this).children("svg").toggleClass("fa-plus fa-minus");
  });

  $("#show_all").click(function(){
    $(".tli_content_body").show();
    $(".tli_content_header").children("svg").removeClass("fa-plus fa-minus").addClass("fa-minus");
    $("#show_all").hide();
    $("#hide_all").show();
  });

  $("#hide_all").click(function(){
    $(".tli_content_body").hide();
    $(".tli_content_header").children("svg").removeClass("fa-plus fa-minus").addClass("fa-plus");
    $("#hide_all").hide();
    $("#show_all").show();
  });

  // Handling for pages with deep-linkable tabs.
  if (
    window.location.pathname.startsWith('/laws/electric-vehicles-for-tax-credit')
    || window.location.pathname.startsWith('/laws/local_examples')
    || window.location.pathname.startsWith('/laws/utility-program-development')
  ) {
    // Trigger tab switch on-load for deep links.
    const hash = window.location.hash;
    if (hash) {
      if (window.location.pathname.startsWith('/laws/local_examples')) {
        if (hash == "#5" || hash == "#6" || hash == "#7" || hash == "#8" || hash == "#9") {
          document.querySelector(`a[data-bs-toggle="tab"][href="#/laws"]`)?.click();
        } else {
          document.querySelector(`a[data-bs-toggle="tab"][href="${hash}"]`)?.click();
        }
      } else {
        document.querySelector(`a[data-bs-toggle="tab"][href="${hash}"]`)?.click();
      }
    }

    // Update URL on tab change for deep linking.
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tabEl) => {
      tabEl.addEventListener('shown.bs.tab', () => {
        window.history.replaceState(null, '', tabEl.getAttribute('href'));
      });
    });
  }
});
